import type { LocaleMessageBundle } from '../../types'

export const authForgotPasswordMessages: LocaleMessageBundle = {
  vi: {
    'auth.forgotPassword.model': 'Tài khoản',
    'auth.forgotPassword.title': 'Quên mật khẩu',
    'auth.forgotPassword.subtitle':
      'Nhập thông tin tài khoản để nhận mật khẩu tạm qua email đã đăng ký',
    'auth.forgotPassword.fields.tenantCode': 'Mã cửa hàng',
    'auth.forgotPassword.fields.username': 'Email hoặc số điện thoại',
    'auth.forgotPassword.placeholders.tenantCode': 'Nhập mã cửa hàng',
    'auth.forgotPassword.placeholders.username': 'Nhập email hoặc số điện thoại',
    'auth.forgotPassword.actions.submit': 'Gửi email',
    'auth.forgotPassword.actions.submitting': 'Đang gửi...',
    'auth.forgotPassword.actions.backToLogin': 'Quay lại đăng nhập',
    'auth.forgotPassword.feedback.success': 'Gửi email thành công',
    'auth.forgotPassword.feedback.failure': 'Gửi email không thành công.',
  },
  en: {
    'auth.forgotPassword.model': 'Account',
    'auth.forgotPassword.title': 'Forgot password',
    'auth.forgotPassword.subtitle':
      'Enter your account information to receive a temporary password by registered email',
    'auth.forgotPassword.fields.tenantCode': 'Tenant code',
    'auth.forgotPassword.fields.username': 'Email or phone number',
    'auth.forgotPassword.placeholders.tenantCode': 'Enter tenant code',
    'auth.forgotPassword.placeholders.username': 'Enter email or phone number',
    'auth.forgotPassword.actions.submit': 'Send email',
    'auth.forgotPassword.actions.submitting': 'Sending...',
    'auth.forgotPassword.actions.backToLogin': 'Back to login',
    'auth.forgotPassword.feedback.success': 'Email sent successfully',
    'auth.forgotPassword.feedback.failure': 'Failed to send email.',
  },
}
